import React from 'react';
import { useSelected } from '@seafile/slate-react';
import Link from '../editor-widgets/link';
import Image from '../editor-widgets/image';
import CheckListItem from '../editor-widgets/check-list-item';
import CodeBlock from '../editor-widgets/code-block';
import Formula from '../editor-widgets/formula';
import TableContainer from '../editor-widgets/table';
import Column from '../editor-widgets/column';
import { decorationNode } from './common-utils';
function WithSelectedState(props) {
  var isSelected = useSelected();
  var SlateNode = props.SlateNode;
  return /*#__PURE__*/React.createElement(SlateNode, {
    editor: props.editor,
    attributes: props.attributes,
    children: props.children,
    isSelected: isSelected,
    node: props.element
  });
}
function renderNode(props, editor) {
  var attributes = props.attributes,
    children = props.children,
    node = props.element;
  switch (node.type) {
    case 'paragraph':
      return /*#__PURE__*/React.createElement("p", attributes, children);
    case 'header_one':
      return /*#__PURE__*/React.createElement("h1", Object.assign({}, attributes, {
        id: 'user-content-' + node.children[0].text
      }), children);
    case 'header_two':
      return /*#__PURE__*/React.createElement("h2", Object.assign({}, attributes, {
        id: 'user-content-' + node.children[0].text
      }), children);
    case 'header_three':
      return /*#__PURE__*/React.createElement("h3", Object.assign({}, attributes, {
        id: 'user-content-' + node.children[0].text
      }), children);
    case 'header_four':
      return /*#__PURE__*/React.createElement("h4", attributes, children);
    case 'header_five':
      return /*#__PURE__*/React.createElement("h5", attributes, children);
    case 'header_six':
      return /*#__PURE__*/React.createElement("h6", attributes, children);
    case 'link':
      return /*#__PURE__*/React.createElement(Link, {
        attributes: attributes,
        children: children,
        node: node
      });
    case 'image':
      return /*#__PURE__*/React.createElement(WithSelectedState, Object.assign({}, props, {
        SlateNode: Image
      }));
    case 'blockquote':
      return /*#__PURE__*/React.createElement("blockquote", attributes, children);
    case 'list_item':
      var checked = node.data.checked;
      if (checked === undefined) return /*#__PURE__*/React.createElement("li", attributes, children);
      return /*#__PURE__*/React.createElement(CheckListItem, Object.assign({
        editor: editor
      }, props));
    case 'code_block':
      return /*#__PURE__*/React.createElement(WithSelectedState, Object.assign({}, props, {
        editor: editor,
        SlateNode: CodeBlock
      }));
    case 'code_line':
      return /*#__PURE__*/React.createElement("p", attributes, children);
    case 'unordered_list':
      return /*#__PURE__*/React.createElement("ul", attributes, children);
    case 'ordered_list':
      return /*#__PURE__*/React.createElement("ol", attributes, children);
    case 'table':
      return /*#__PURE__*/React.createElement(TableContainer, Object.assign({
        editor: editor
      }, props));
    case 'table_row':
      return /*#__PURE__*/React.createElement("tr", attributes, children);
    case 'table_cell':
      var align = node.data.align;
      align = ['left', 'right', 'center'].find(function (item) {
        return item === align;
      }) ? align : 'left';
      return /*#__PURE__*/React.createElement("td", Object.assign({
        style: {
          textAlign: align
        }
      }, attributes), children);
    case 'formula':
      return /*#__PURE__*/React.createElement(WithSelectedState, Object.assign({}, props, {
        editor: editor,
        SlateNode: Formula
      }));
    case 'column':
      return /*#__PURE__*/React.createElement(WithSelectedState, Object.assign({}, props, {
        editor: editor,
        SlateNode: Column
      }));
    default:
      return /*#__PURE__*/React.createElement("p", attributes, children);
  }
}
var renderLeaf = function renderLeaf(_ref) {
  var attributes = _ref.attributes,
    children = _ref.children,
    leaf = _ref.leaf;
  var markedChildren = React.cloneElement(children);
  if (leaf.BOLD) {
    markedChildren = /*#__PURE__*/React.createElement("strong", null, markedChildren);
  }
  if (leaf.CODE) {
    markedChildren = /*#__PURE__*/React.createElement("code", null, markedChildren);
  }
  if (leaf.ITALIC) {
    markedChildren = /*#__PURE__*/React.createElement("i", null, markedChildren);
  }
  if (leaf.DELETE) {
    markedChildren = /*#__PURE__*/React.createElement("del", null, markedChildren);
  }
  if (leaf.ADD) {
    markedChildren = /*#__PURE__*/React.createElement("ins", null, markedChildren);
  }
  if (leaf.decoration) {
    markedChildren = /*#__PURE__*/React.createElement("span", {
      className: "token ".concat(leaf.type)
    }, markedChildren);
  }
  return /*#__PURE__*/React.createElement("span", attributes, markedChildren);
};
export { renderNode, renderLeaf, decorationNode };